import { API_ENDPOINT_NAME } from './fanvoiceActions.js';
import { getNamespacedFetchActionTypes, } from '../../jsCore/application/sagas/fetchSaga';
import { memoizeFirstCall } from '../../jsCore/utils/fn';
const INITIAL_STATE = {
  IS_INITIALIZED: false,
  emptyPlaceholdersCount: 6
};

function setState(state, newState){
  return { ...state, ...newState };
}


export function fanvoiceReducer(state = INITIAL_STATE, action){
  const { FANVOICE_ACTION_TYPES } = memoizeFirstCall('FANVOICE_ACTION_TYPES', getNamespacedFetchActionTypes, API_ENDPOINT_NAME);
  if (FANVOICE_ACTION_TYPES) {
    switch (action.type) {
      case FANVOICE_ACTION_TYPES.FETCH.SUCCESS:
      case FANVOICE_ACTION_TYPES.FETCH.FAILED:
        return setState(state, action.state);
      default:
        return state;
    }
  }
  return setState(state, { IS_ENTRY_POINT_MISSING: true });
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fanvoice/fanvoiceReducer.js